'use strict';

exports.__esModule = true;

var _symbolObservable = require('symbol-observable');

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var getObservableFrom;

exports.default = getObservableFrom = function (obj) {
  var getter;
  getter = obj[_symbolObservable2.default];
  return getter != null ? getter.call(obj) : void 0;
};